import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { offerNewVersion } from "./lib/chunk-recovery";
import { startBuildWatch } from "./lib/build-freshness";
import "./styles.css";

// Vite fires this when the <link rel=modulepreload> for a route chunk fails —
// the same stale-bundle-after-a-deploy case lazyPage() handles in App.tsx, but
// caught a step earlier, before the import itself is attempted. Swallowing the
// event makes the import resolve undefined, which lazyPage treats as the
// missing-chunk case; the toast offers the reload.
window.addEventListener("vite:preloadError", ((e: Event) => {
  offerNewVersion();
  e.preventDefault();
}) as EventListener);

// Client-side routes live under /ops (e.g. /ops/login, /ops/home). The
// Express SPA fallback serves ops/dist/index.html for any /ops/* path
// that isn't /ops/auth/*, /ops/api/*, or /ops/static/*.
// Notice deploys before a navigation trips over one (lib/build-freshness.ts).
startBuildWatch();

const root = document.getElementById("root");
if (!root) throw new Error("#root not found");

createRoot(root).render(
  <StrictMode>
    <BrowserRouter basename="/ops">
      <App />
    </BrowserRouter>
  </StrictMode>,
);
